var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"app-content"},[(_vm.app.screen === 'home')?_c('home'):_vm._e(),(_vm.app.screen === 'game')?_c('game'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }